<template>
  <v-card dark max-width="500">
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar size="32">
          <img v-if="log.user.avatar.url !== null" :src="log.user.avatar.url"/>
          <span v-else>{{ acronym(log.user.name) }}</span>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>{{ startCaseText(log.user.name) }}</v-list-tile-title>
          <v-list-tile-sub-title v-if="log.user.role">{{ log.user.role.name }}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>

      <div class="activity-detail-document-info">
        <div class="document-description">
          {{ activity.description }}
        </div>

        <div v-if="!isEmpty(activity.document_type_name)">
          <v-icon size="16">mdi mdi-file-document</v-icon>
          <strong>{{activity.document_type_name}}</strong>
        </div>
      </div>


    </v-list>

    <v-divider/>

    <v-card-text class="text-xs-center">
      <span>
      <v-icon size="16">mdi mdi-calendar-range</v-icon>
        {{ formatLongDate(activity.created_at) + ' às ' + hour(activity.created_at)}}
      </span>
    </v-card-text>
  </v-card>
</template>

<script>
import { capitalize, startCase, lowerCase, isEmpty } from 'lodash';
import acronym from '@/utils/acronym';
import format from 'date-fns/format';
import * as ptLocale from 'date-fns/locale/pt';

export default {
  name: 'activity-detail-card',
  props: ['log', 'activity'],
  methods: {
    isEmpty,
    formatLongDate(date) {
      const day = format(date, 'DD');
      const month = format(date, 'MMMM', { locale: ptLocale });
      const year = format(date, 'YYYY', { locale: ptLocale });
      return `${day} de ${capitalize(month)} de ${year}`;
    },
    hour(date) {
      return format(date, 'HH:mm', { locale: ptLocale });
    },
    acronym(string) {
      return acronym(string);
    },
    startCaseText(string) {
      return startCase(lowerCase(string));
    },
    capitalizeText(string) {
      return capitalize(string);
    },
  },
};
</script>

<style lang="scss" scoped>
  .activity-detail-document-info {
    margin: 0 15px;
    max-width: 400px;
    text-align: justify;

    .document-description {
      margin-bottom: 10px;
      font-size: 14px
    }

  }

  .v-avatar{
    background-color: #616161 !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/folder/activity-log/ActivityDetailCard.vue